import { Component } from 'react';
import propTypes from 'prop-types';
import { observer } from 'mobx-react';

class _QtyStatic extends Component {
  render() {
    return (
      <>
        {this.props.label && <span>{this.props.label}</span>}
        <span>{this.props.item.quantity}</span>
      </>
    );
  }
}

_QtyStatic.propTypes = {
  item: propTypes.shape({
    quantity: propTypes.number.isRequired
  }).isRequired,
  label: propTypes.string
};

export const QtyStatic = observer(_QtyStatic);
